import React from 'react'
import classNames from 'classnames'

import { ButtonOutline } from 'front-end/src/components'

import IconTick from '../../../../components/common/icon/IconTick'
import IconX from '../../../../components/common/icon/IconX'
import Spinner from '../../../../components/common/loader/Loader'
import { IStudentSurveyQuestionTypeProps } from '../StudentSurveyQuestion'

import './BoolQuestion.less'

const BoolQuestion = ({
  question,
  setAnswer,
  answer
}: IStudentSurveyQuestionTypeProps) => {
  if (!question) {
    return <Spinner />
  }

  const options = question.content?.options ?? []

  return (
    <div className="BoolQuestion">
      {options.map((option, index) => {
        const isActive = option?.id === answer
        const btnClasses = classNames({ 'Button--selected': isActive })

        return (
          <ButtonOutline
            key={option.id}
            aria-pressed={isActive}
            className={btnClasses}
            onClick={() => {
              setAnswer(option.id)
            }}
            leftIcon={index === 0 ? <IconX /> : <IconTick />}
          >
            <span className="BoolQuestion__label">{option.label}</span>
          </ButtonOutline>
        )
      })}
    </div>
  )
}

export default BoolQuestion
